import { useCallback } from 'react';
import { IErrorResponse } from 'src/utilities/shared-types';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { executeCorporateSetup } from 'src/components/enterprise/features/Corporate/CreatePage/functions/corporateSetup';
import { createCorporateModel } from 'src/components/enterprise/features/Corporate/utils/corporate.utilities';
import { transformCateringServiceFeeUIToModel } from 'src/components/enterprise/features/Corporate/components/Form/CateringServiceFeeControl/cateringServiceFeeControl.utils';

export type UseCreateCorporateReturnType = {
  createCorp: (values: CorporateFormFields) => Promise<void>;
};

export type UseCreateCorporateProps = {
  onSuccess: () => Promise<void>;
  onError: (error: IErrorResponse | SdkErrorResponse) => Promise<void>;
};

export const useCreateCorporate = ({
  onSuccess,
  onError,
}: UseCreateCorporateProps): UseCreateCorporateReturnType => {
  const createCorpTrigger = useCallback(
    async (values: CorporateFormFields): Promise<void> => {
      const { cateringServiceFee, ...corporateData } = values;
      const corporatePayload = createCorporateModel(corporateData);
      const cateringServiceFeePayload =
        transformCateringServiceFeeUIToModel(cateringServiceFee);

      try {
        await executeCorporateSetup(
          corporatePayload,
          cateringServiceFeePayload,
          values.universalAccountsEnabled
        );
        await onSuccess();
      } catch (error) {
        await onError(error);
      }
    },
    [onSuccess, onError]
  );

  return {
    createCorp: createCorpTrigger,
  };
};
